export default "__VITE_ASSET__UAX0zLBc__"